import { OwaDate, getISOString } from 'owa-datetime';
import ApplyMessageActionRequest from 'owa-service/lib/contract/ApplyMessageActionRequest';
import ApplyMessageActionResponseMessage from 'owa-service/lib/contract/ApplyMessageActionResponseMessage';
import applyMessageActionRequest from 'owa-service/lib/factory/applyMessageActionRequest';
import itemId from 'owa-service/lib/factory/itemId';
import messageAction from 'owa-service/lib/factory/messageAction';
import applyMessageActionOperation from 'owa-service/lib/operation/applyMessageActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Schedule item service
 * @param itemIds the itemIds to be scheduled
 * @param scheduleReturnTime the time item will return or undefined to unschedule
 * @return the ApplyMessageActionResponseMessage
 */
export default function scheduleItemsService(
    itemIds: string[],
    scheduleReturnTime?: OwaDate | undefined
): Promise<ApplyMessageActionResponseMessage[]> {
    const requestBody = configureRequestBody(itemIds, scheduleReturnTime);

    return applyMessageActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items;
    });
}

/**
 * Configure the request body
 * @param itemIds the itemIds to be restored
 * @return the ApplyMessageActionResponseMessage body
 */
function configureRequestBody(
    itemIds: string[],
    scheduleReturnTime: OwaDate | undefined
): ApplyMessageActionRequest {
    return applyMessageActionRequest({
        MessageAction: messageAction({
            Action: scheduleReturnTime ? 'Schedule' : 'Unschedule',
            ScheduleReturnTime: scheduleReturnTime ? getISOString(scheduleReturnTime) : null,
        }),
        Ids: itemIds.map(itemIdValue => itemId({ Id: itemIdValue })),
    });
}
